var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "about_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 46H6V2h36v22M14 14h19.906M14 24h19.906M13.906 34H22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 36v10H30V36l8-6 8 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272726",
    stroke: "none",
    d: "M36 40h4v6h-4z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+cHJvcGVydHkgYWdyZWVtZW50PC90aXRsZT48ZyBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMjcyNzI2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIj48cG9seWxpbmUgcG9pbnRzPSIyNCA0NiA2IDQ2IDYgMiA0MiAyIDQyIDI0Ij48L3BvbHlsaW5lPjxsaW5lIHgxPSIxNCIgeTE9IjE0IiB4Mj0iMzMuOTA2IiB5Mj0iMTQiPjwvbGluZT48bGluZSB4MT0iMTQiIHkxPSIyNCIgeDI9IjMzLjkwNiIgeTI9IjI0Ij48L2xpbmU+PGxpbmUgeDE9IjEzLjkwNiIgeTE9IjM0IiB4Mj0iMjIiIHkyPSIzNCI+PC9saW5lPjxwb2x5Z29uIHBvaW50cz0iNDYgMzYgNDYgNDYgMzAgNDYgMzAgMzYgMzggMzAgNDYgMzYiIHN0cm9rZT0iIzI3MjcyNiI+PC9wb2x5Z29uPjxyZWN0IHg9IjM2IiB5PSI0MCIgd2lkdGg9IjQiIGhlaWdodD0iNiIgc3Ryb2tlPSJub25lIiBmaWxsPSIjMjcyNzI2Ij48L3JlY3Q+PC9nPjwvc3ZnPg==";
export { SvgAbout as ReactComponent };